import { RESET, SET_EDIT_MODAL } from "../../utils/constants";

const initialState = () => ({
  headers: [
    {
      text: "Szabályozó neve",
      value: "name",
      sortable: true,
      divider: true
    },
    {
      text: "Aktív",
      value: "is_active",
      sortable: true,
      divider: true
    },
    {
      text: "Létrehozva",
      value: "created_at",
      sortable: true,
      divider: true
    },
    {
      text: "Utoljára frissítve",
      value: "updated_at",
      sortable: true,
      divider: true
    },
    {
      text: "Lehetőségek",
      value: "actions",
      sortable: false
    }
  ],
  regulator: {}
});

const state = {
  ...initialState(),
  regulators: []
};

const getters = {};

Object.keys(state).forEach(key => {
  Object.assign(getters, {
    [key]: state => state[key]
  });
});

const actions = {
  reset({ commit }) {
    commit(RESET);
  },
  getRegulators({ state, rootGetters, dispatch }) {
    // const page = rootGetters["Table/page"];
    // const limit = rootGetters["Table/limit"];
    // const search = rootGetters["Table/search"];

    const params = rootGetters["Table/params"];

    axios({
      method: "GET",
      url: "regulators",
      params
    }).then(response => {
      state.regulators = response.data.data;

      dispatch("Table/rowsLoaded", { ...response.data.meta }, { root: true });
    });
  },
  createRegulator({ state, dispatch }) {
    axios({
      method: "POST",
      url: "regulators",
      data: {
        ...state.regulator
      }
    }).then(() => {
      dispatch("getRegulators");
    });
  },
  editRegulator({ state, commit }, { id }) {
    axios(`regulators/${id}`).then(response => {
      state.regulator = response.data.data;
      commit(`Modal/${SET_EDIT_MODAL}`, true, { root: true });
    });
  },
  updateRegulator({ state, dispatch }) {
    axios({
      method: "PATCH",
      url: `regulators/${state.regulator.id}`,
      data: {
        ...state.regulator
      }
    }).then(() => {
      dispatch("getRegulators");
    });
  },
  deleteRegulatorById({ dispatch }, id) {
    axios({
      method: "DELETE",
      url: `regulators/${id}`
    }).then(() => {
      dispatch("getRegulators");
    });
  },
  getAllRegulators({ state }) {
    axios("all/regulators").then(response => {
      state.regulators = response.data.data;
    });
  }
};

const mutations = {
  [RESET](state) {
    Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
